import { colors } from '../../colors';
var address = {
  addressColor: colors.charcoalGrey
};
export default address;